<div class="card">
    <p-toast />
    <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
        <div><h4><strong style="font-size: large; margin-left:10px" style="color: black;">Approve Vendor List</strong></h4></div>
        <div class="grid">
            <p-button *ngIf="isListView" label="Card View" (click)="cardView()" class="mr-2"/>
            <p-button *ngIf="isCardView" label="List View" (click)="listView()" class="mr-2"/>
        <!-- <button pButton type="button"  style="height:10px; margin-top: -0px; background-color:black" label="Report"></button>     -->
        <button pButton type="button" icon="pi pi-download" (click)="onClickExcel()"  label="Excel Report"></button>
          <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
        </div>
    </div>
    <hr>

    <div *ngIf="isCardView" class="grid">
        <!-- <div class="search-bar">
            <input type="text" [(ngModel)]="searchTerm" (input)="applySearch()" placeholder="Search rewards..." class="form-control">
          </div>     -->
        <div *ngFor="let vendor of vendorList">
            <div class="col">
                <app-vendor-detail-card  [vendor]="vendor"></app-vendor-detail-card>
            </div>
        </div>
        <!-- <p-paginator [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[5, 10, 20, 30]"
        (onPageChange)="onPageChange($event)">
        </p-paginator> -->
    </div>

    <!-- <div style="display: flex; justify-content:end; margin-bottom:20px;">
        <p-button
            pRipple
            severity="success"
            label="Approve"
            icon="pi pi-check"
            class="mr-2"
            (click)="deleteSelectedProducts()"
            [disabled]="!selectedVendor || !selectedVendor.length"
           />
    </div> -->
        <p-table *ngIf="isListView" [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines"
        [showCurrentPageReport]="true" [columns]="cols" [tableStyle]="{ 'min-width': '150rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <!-- <th style="width: 4rem">
                    <p-tableHeaderCheckbox />
                </th> -->
                <th class="bg-orange"></th>
                <th  class="bg-orange" *ngFor="let col of columns">
                  {{ col.header }}
              </th>
            </tr>
            <tr>
              <th></th>
              <th *ngFor="let col of cols">
                <ng-container *ngIf="col.field === 'creation_date'; else textInput">
                  <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                </ng-container>
                <ng-template #textInput>
                  <ng-container *ngIf="col.field != 'state' && col.field != 'country'">
                    <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                  </ng-container>
                </ng-template>
                  <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
              </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
                <!-- <td>
                    <p-tableCheckbox [value]="vendor" />
                </td> -->
                <td>
                    <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.get_user,vendor.status,vendor.business_name)" class="p-button-rounded" pTooltip="View Details"></button>
                </td>
                <td><strong>{{ vendor.business_name }}</strong></td>
                <td><strong>{{ vendor.vendor_code }}</strong></td>
                <td><strong>{{ vendor.address_title }}</strong></td>
                <!-- <td>{{ vendor.vendor_group }}</td> -->
                <td><strong>{{vendor.city}}</strong></td>
                <td><strong>{{getStateLabel(vendor.state,vendor.country)}}</strong></td>
                <td><strong>{{getcountries(vendor.country)}}</strong></td>
                <td><strong>{{vendor.gstn}}</strong></td>
                <td><strong>{{vendor.pan_no}}</strong></td>
                <td><strong>{{vendor.select_industry_type}}</strong></td>
                <td><strong>{{vendor.payment_term}}</strong></td>
                <td><strong>{{vendor.new_account_group}}</strong></td>
                <td><strong>{{vendor.purchase_organization}}</strong></td>
                <td><strong>{{vendor.status}}</strong></td>
                <td><strong>{{vendor.creation_date  | date:'dd.MM.yyyy'}}</strong></td>
                <td><strong>{{vendor.is_black_list}}</strong></td>
                <td><strong>{{vendor.is_legal_case}}</strong></td>
                <td><strong>{{vendor.black_list_remark}}</strong></td>
                <!-- <td>
                    <p-button label="Change" icon="pi pi-user-edit" (click)="goToChangeRequest(vendor.vendor_code)"></p-button>
                </td> -->
            </tr>
        </ng-template>
    </p-table>
    <div>
      <p-paginator
      [rows]="limit"
      [first]="(currentPage - 1) * limit"
      [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)"
      [rowsPerPageOptions]="[10, 20,30,50,100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
       />
  </div>
</div>
<p-dialog header="Header" [closable]="false" [(visible)]="isExcel" [modal]="true" [style]="{ width: '35rem'}"
[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
<ng-template pTemplate="header">
    <!-- <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">Select Date</span>
    </div> -->
</ng-template>
<ng-template pTemplate="footer">
    <p-button (click)="onCloseForExcelReport()" label="Close" pAutoFocus [autofocus]="true"></p-button>
    <p-button (click)="onDowunloadVendorListByDate()" label="Download" pAutoFocus [autofocus]="true"></p-button>
</ng-template>
    <div class="grid">
        <div class="col">
            <label class="font-bold block mb-2"><strong>Start Date</strong></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" [(ngModel)]="startDate" appendTo="body" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true"></p-calendar>
            </div>
        </div>
        <div class="col">
            <label class="font-bold block mb-2"><strong>End Date</strong></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" appendTo="body" [(ngModel)]="endDate" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true"></p-calendar>
                <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
                <!-- <div *ngIf="endDate && startDate && endDate < startDate" class="text-red-500">End date cannot be before start date.</div>
                <div *ngIf="dateValidation1 && endDate && getDateDifference() > 12" class="text-red-500">The end date cannot be more than 1 Year after the start date.</div> -->
            </div>
        </div>
    </div>
    <div class="grid">
      <div class="col">
        <label><strong>Purchase Organization</strong></label>
        <input pInputText [(ngModel)]="purchase_organization" style="width: 100%;" />
      </div>
      <div class="col">
        <label><strong>Vendor Code</strong></label>
        <input pInputText [(ngModel)]="vendorNames" style="width: 100%;" />
      </div>
    </div>

</p-dialog>
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
<p-toast></p-toast>
